import React from 'react';

const SEO = ({ 
  title = "DatLynk | Structure-Aware Jira & ClickUp Sync",
  description = "DatLynk keeps Jira and ClickUp hierarchies, tasks, subtasks, and mapped fields aligned without manual cleanup. Available now, built to expand across your workflow.",
  keywords = "DatLynk, Jira ClickUp sync, hierarchy-aware sync, two-way sync, task mapping, project management sync, structure-aware sync",
  image = "/datlynk-social-card.png",
  url = window.location.href,
  type = "website"
}) => {
  // Update document title
  React.useEffect(() => {
    document.title = title;
  }, [title]);

  // Update meta tags
  React.useEffect(() => {
    const updateMetaTag = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let element = document.querySelector(selector);
      
      if (!element) {
        element = document.createElement('meta');
        if (property) {
          element.setAttribute('property', name);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', 'DatLynk');
    updateMetaTag('viewport', 'width=device-width, initial-scale=1.0');
    
    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:site_name', 'DatLynk', true);
    
    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    
    // Additional SEO tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('language', 'en');
    updateMetaTag('revisit-after', '7 days');
    
  }, [title, description, keywords, image, url, type]);

  return null;
};

export default SEO;